import Paths from '../utils/Paths';
import { getAuthData } from '../utils/authDataStorage';
import axios, { AxiosError } from 'axios';
import { redirect } from 'react-router-dom';

export const apiClient = axios.create({
  baseURL: import.meta.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const session = getAuthData();
  if (session?.accessToken) {
    config.headers.Authorization = `Bearer ${session.accessToken}`;
  }
  return config;
});

export const getUserInfo = () => {
  const session = getAuthData();
  if (!session?.accessToken) throw redirect(Paths.SIGN_IN);
  return {
    accessToken: session.accessToken,
    username: session.user.name,
  };
};

export const getErrorResponseData = (error: AxiosError) => error.response?.data;
